import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private api = environment.apiUrl;

  constructor(private http: HttpClient) {
    console.log('ApiService base URL:', this.api);
  }

  post<T>(url: string, body: unknown) {
    console.log('POST URL:', `${this.api}${url}`);
    return this.http.post<T>(`${this.api}${url}`, body);
  }

  get<T>(url: string) {
    console.log('GET URL:', `${this.api}${url}`);
    return this.http.get<T>(`${this.api}${url}`);
  }

  postFormData<T>(url: string, formData: FormData) {
    return this.http.post<T>(`${this.api}${url}`, formData);
  }

  delete<T>(url: string) {
    return this.http.delete<T>(`${this.api}${url}`);
  }
}
